import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import Tooltip from "@mui/material/Tooltip";
import LoadingSpinner from "./LoadingSpinner";
import "./Modal.css";

function ModalMediaOld({ open, fName, media, video, onClose }) {
  const download = (fname, mediaa) => {
    const linkSource = mediaa;
    const downloadlink = document.createElement("a");
    const filename = fname;

    downloadlink.href = linkSource;
    downloadlink.download = filename;
    downloadlink.click();
  };

  const playVideo = () => {
    return (
      <div className="modalMedia">
        <video className="videoMedia" controls>
          <source src={video} />
        </video>
      </div>
    );
  };

  if (!open) return null;

  return (
    <div className="overlayMedia">
      {video ? (
        <Tooltip title="Download" arrow>
          <DownloadIcon
            className="DownloadBtnMedia"
            sx={{ fontSize: 36 }}
            onClick={() => download(fName, video)}
          />
        </Tooltip>
      ) : (
        <Tooltip title="Download" arrow>
          <DownloadIcon
            className="DownloadBtnMedia"
            sx={{ fontSize: 36 }}
            onClick={() => download(fName, media)}
          />
        </Tooltip>
      )}

      <Tooltip title="Exit" arrow>
        <CloseOutlinedIcon
          className="closeBtnMedia"
          sx={{ fontSize: 36 }}
          onClick={onClose}
        />
      </Tooltip>

      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainerMedia"
      >
        {!video && !media ? <LoadingSpinner /> : ""}

        {video ? (
          playVideo()
        ) : (
          <div className="modalMedia">
            <img alt="" src={media} />
          </div>
        )}
      </div>
    </div>
  );
}

export default ModalMediaOld;
